import { DatePicker } from 'pg-ui-library';
import styled from 'styled-components';

export const CreateBenificiariesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CreateBenificiariesFirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  width: 180px;
  margin-right: 10px;
`;
export const CreateBenificiariesSecondRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  margin-right: 10px;
`;
export const CreateBenificiariesThirdRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
`;

export const CreateBenificiariesContainerSave = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -40px;
  margin-top: 40px;
`;

export const CustomDatePicker = styled(DatePicker)`
  border: 1px black solid;
  min-width: 180px;
  max-width: 180px;
  margin-right: 4px;
  color: black;
  max-height: 300px;
`;

export const BeneficiariesInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 85px;
`;

export const BeneficiariesInputError = styled.p`
  font-size: 10pt;
  color: red;
`;
